/*
 * @Author: hql hql18293442408@163.com
 * @Date: 2025-07-28 09:41:46
 * @LastEditors: hql hql18293442408@163.com
 * @LastEditTime: 2025-08-08 16:43:42
 * @FilePath: \dangjian-portrait\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
import store from '../store.js'

// 创建axios实例
const service = axios.create({
  // baseURL: "/", //   基础URL，可从环境变量获取
  timeout: 50000, // 请求超时时间
  // headers: {
  //   'Content-Type': 'application/json;charset=utf-8'
  // }
})

// 请求计数器，用于管理多个并发请求
let requestCount = 0

// 显示加载框的函数
function showLoading() {
  if (requestCount === 0) {
    // 只有在没有请求时才显示加载框
    store.commit('showLoading', { 
      subText: '请稍候...'
    })
  }
  requestCount++
}
// 隐藏加载框的函数
function hideLoading() {
  requestCount--
  if (requestCount <= 0) {
    // 所有请求都完成后才隐藏加载框
    requestCount = 0
    store.commit('hideLoading')
  }
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 显示加载框
    
    // 定义不需要显示加载框的接口数组
    const excludeUrls = ['get_today_cfl_realtime', 'clinic_kfsl_v2']
    // console.log(excludeUrls)
    // 检查当前请求是否在排除列表中
    const shouldExclude = excludeUrls.some(url => config.url.indexOf(url) > -1)
    // console.log(shouldExclude)
    if (!shouldExclude) {
      showLoading()
    }
    
    return config
  },
  error => {
    // 请求出错时也要隐藏加载框
    hideLoading()
    // 处理请求错误
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 隐藏加载框
    
    hideLoading()
    
    const res = response
    return res
  },
  error => {
    // 响应出错时也要隐藏加载框
    hideLoading()
    
    // 处理响应错误
    console.error('响应错误:', error.message)
    // 可添加网络错误、401、403等状态码的处理逻辑
    return Promise.reject(error)
  }
)

export default service
